import React, { useState, useRef, useEffect } from 'react';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from '@material-ui/core';
import { RecordVoiceOver } from '@material-ui/icons';

const styles = theme => ({
  outerContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: 12,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    overflow: 'hidden',
  },
  header: {
    padding: '16px 24px',
    borderBottom: '1px solid #e0e0e0',
    textAlign: 'left',
  },
  iconHeader: {
    padding: '8px 12px',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  headerText: {
    fontSize: '20px',
    color: '#1e5180',
    fontWeight: 500,
    textAlign: 'left',
  },
  transcriptContainer: {
    flex: 1,
    padding: '24px',
    overflowY: 'scroll', // Force scrollbar to always be visible
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '4px',
      '&:hover': {
        background: '#a8a8a8',
      },
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    borderBottom: '1px solid #e0e0e0',
    paddingLeft: 24,
  },
  message: {
    marginBottom: '24px',
    textAlign: 'left',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  messageHeader: {
    fontSize: '14px',
    marginBottom: '8px',
    textAlign: 'left',
  },
  assistantHeader: {
    color: '#1976d2',
  },
  customerHeader: {
    color: '#f5a623',
  },
  messageContent: {
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
  inputContainer: {
    padding: '16px 24px',
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start',
  },
  input: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
    '& .MuiInputBase-input': {
      textAlign: 'left',
    },
  },
  sendButton: {
    backgroundColor: '#3a87ad',
    color: 'white',
    borderRadius: '8px',
    textTransform: 'none',
    padding: '8px 24px',
    '&:hover': {
      backgroundColor: '#2a6d8d',
    },
  },
});

const Transcript = withStyles(styles)(({ classes, transcript = [], loading }) => {
  const [inputMessage, setInputMessage] = useState('');
  const transcriptRef = useRef(null);

  // Scroll to bottom when new messages arrive
  useEffect(() => {
    if (transcriptRef.current) {
      transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
    }
  }, [transcript]);

  // Force scrollbar position on component mount
  useEffect(() => {
    if (transcriptRef.current) {
      transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
    }
  }, []);

  return (
    <>
      <div className={classes.iconContainer} style={{ paddingLeft: 8 }}>
        <div className={classes.iconHeader} style={{ gap: 8 }}>
          <RecordVoiceOver />
          <Typography className={classes.headerText}>Call Transcript</Typography>
        </div>
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div
            ref={transcriptRef}
            className={classes.transcriptContainer}
            style={{ maxHeight: '300px' }} // Ensure there's a reasonable max height
          >
            {transcript
              .filter(msg => msg.role === 'bot' || msg.role === 'user')
              .map((message, index) => (
                <div key={index} className={classes.message}>
                  <Typography
                    className={`${classes.messageHeader} ${
                      message.role === 'bot' ? classes.assistantHeader : classes.customerHeader
                    }`}
                  >
                    {message.role === 'bot' ? 'Assistant:' : 'Customer:'}
                  </Typography>
                  <Typography className={classes.messageContent}>{message.message}</Typography>
                </div>
              ))}
          </div>
          {/* <div className={classes.inputContainer}>
              <TextField
                className={classes.input}
                variant="outlined"
                placeholder="Type a message to the AI assistant..."
                value={inputMessage}
                onChange={e => setInputMessage(e.target.value)}
                size="small"
              />
              <Button className={classes.sendButton} variant="contained" disableElevation>
                Send
              </Button>
            </div> */}
        </>
      )}
    </>
  );
});

export default Transcript;
